import Cta7Morph from './Cta7Morph'
export default Cta7Morph
